import React from 'react';
import { fetchAgentScripts } from './agentScriptsApi';

/**
 * Loads the user's editable (owner-only) agent scripts for the Improve
 * selector. Filtering to `is_editable` hides the 403 "not the owner" case.
 */
export const useEditableAgentScripts = () => {
  const [scripts, setScripts] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);

  const reload = React.useCallback(async () => {
    setIsLoading(true);
    const all = await fetchAgentScripts();
    const editable = all.filter((script) => script.is_editable === true);
    setScripts(editable);
    setIsLoading(false);
  }, []);

  React.useEffect(() => {
    reload();
  }, [reload]);

  return { scripts, isLoading, reload };
};
